<template>
  <div>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text top right
    >
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <!-- Modal de selección de productos -->
      <ProductosDialogCompra
        ref="productosDialog"
        @seleccionado="recibirProducto"
      ></ProductosDialogCompra>

      <!-- Modal de edición de compra -->
      <EditarCompraDialog
        ref="editarCompraDialog"
        @actualizado="despuesDeActualizar"
      ></EditarCompraDialog>

      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Compras</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
        <v-tab href="#one">
          <v-icon left>mdi-cart-arrow-down</v-icon>
          Registro
        </v-tab>
        <v-tab href="#two">
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
      </v-tabs>

      <v-tabs-items :value="tab">

        <!-- ============================== -->
        <!-- TAB 1 — FORMULARIO             -->
        <!-- ============================== -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>

                  <!-- SECCIÓN: DATOS DEL COMPROBANTE -->
                  <v-col cols="12">
                    <v-sheet color="grey lighten-1" class="pa-3 mt-1">
                      <strong>DATOS DEL COMPROBANTE</strong>
                    </v-sheet>
                  </v-col>

                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-text-field
                      v-model="compra.comprobante_numero"
                      label="N° Comprobante"
                      disabled
                      outlined dense
                      hint="Generado automáticamente"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-text-field
                      v-model="compra.fecha_registro"
                      label="Fecha de Registro"
                      disabled
                      outlined dense
                      hint="Automático al guardar"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-text-field
                      v-model="compra.fecha_documento"
                      label="Fecha de Documento"
                      disabled
                      outlined dense
                      hint="Automático al guardar"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <!-- SECCIÓN: INFORMACIÓN DE LA OPERACIÓN -->
                  <v-col cols="12">
                    <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                      <strong>INFORMACIÓN DE LA OPERACIÓN</strong>
                    </v-sheet>
                  </v-col>

                  <v-col cols="12" sm="6" md="6" lg="6">
                    <v-sheet class="pa-3" elevation="0" outlined rounded>
                      <v-radio-group
                        v-model="compra.condicion"
                        row
                        label="Condición de Pago"
                        :rules="[v => !!v || 'Campo requerido']"
                      >
                        <v-radio label="CONTADO" value="CONTADO"></v-radio>
                        <v-radio label="CRÉDITO" value="CREDITO"></v-radio>
                      </v-radio-group>
                    </v-sheet>
                  </v-col>

                  <v-col cols="12" sm="6" md="6" lg="6">
                    <v-textarea
                      v-model="compra.obs"
                      label="Observaciones"
                      outlined
                      dense
                      rows="2"
                      auto-grow
                    ></v-textarea>
                  </v-col>

                  <!-- SECCIÓN: IMPORTES -->
                  <v-col cols="12">
                    <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                      <strong>IMPORTES</strong>
                    </v-sheet>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      v-model.number="compra.total_excenta"
                      label="Total Exenta"
                      type="number"
                      outlined dense
                      @input="recalcularTotales"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      v-model.number="compra.total_gravada5"
                      label="Gravada 5%"
                      type="number"
                      outlined dense
                      @input="recalcularTotales"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :value="ivaCalculado5"
                      label="IVA 5% (calculado)"
                      type="number"
                      outlined dense
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      v-model.number="compra.total_gravada10"
                      label="Gravada 10%"
                      type="number"
                      outlined dense
                      @input="recalcularTotales"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :value="ivaCalculado10"
                      label="IVA 10% (calculado)"
                      type="number"
                      outlined dense
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :value="montoTotalCalculado"
                      label="Monto Total"
                      type="number"
                      outlined dense
                      disabled
                    ></v-text-field>
                  </v-col>

                  <!-- SECCIÓN: DETALLE DE PRODUCTOS -->
                  <v-col cols="12">
                    <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                      <strong>DETALLE DE PRODUCTOS</strong>
                    </v-sheet>
                  </v-col>

                  <!-- Fila para agregar detalle -->
                  <v-col cols="12" sm="5" md="5" lg="5">
                    <v-text-field
                      :value="detalleActual.producto ? detalleActual.producto.descripcion : ''"
                      label="Producto seleccionado"
                      outlined dense
                      disabled
                      placeholder="Presione Buscar para seleccionar"
                    >
                      <template v-slot:append>
                        <v-btn
                          small
                          color="primary"
                          class="mt-n1"
                          @click="$refs.productosDialog.openDialog()"
                        >
                          <v-icon small left>mdi-magnify</v-icon>
                          Buscar
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="2" md="2" lg="2">
                    <v-text-field
                      v-model.number="detalleActual.cantidad"
                      label="Cantidad"
                      type="number"
                      min="1"
                      outlined dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="3" md="3" lg="3">
                    <v-text-field
                      v-model.number="detalleActual.precio_costo"
                      label="Precio Costo"
                      type="number"
                      min="0"
                      outlined dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="2" md="2" lg="2" class="d-flex align-center">
                    <v-btn color="primary" outlined @click="agregarDetalle">
                      <v-icon left>mdi-plus</v-icon>
                      Agregar
                    </v-btn>
                  </v-col>

                  <!-- Tabla de detalles -->
                  <v-col cols="12" v-if="detalles.length > 0">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Producto</th>
                            <th>Cantidad</th>
                            <th>Precio Costo</th>
                            <th>Subtotal</th>
                            <th>Quitar</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(det, i) in detalles" :key="i">
                            <td>{{ det.producto.descripcion }}</td>
                            <td>{{ det.cantidad }}</td>
                            <td>{{ det.precio_costo }}</td>
                            <td>{{ det.cantidad * det.precio_costo }}</td>
                            <td>
                              <v-btn icon small color="red" @click="quitarDetalle(i)">
                                <v-icon small>mdi-delete</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>

                </v-row>

                <!-- BOTONES -->
                <v-row class="mt-4">
                  <v-col>
                    <v-btn
                      :disabled="!valid"
                      color="success"
                      class="mr-4"
                      @click="registrar"
                    >
                      Registrar
                    </v-btn>
                    <v-btn color="error" class="mr-4" @click="limpiar">
                      Cancelar
                    </v-btn>
                  </v-col>
                </v-row>

              </v-form>
            </v-card-text>

            <v-card-text>
              <v-alert colored-border type="info" elevation="2">
                La fecha, número de comprobante y empresa se asignan automáticamente al registrar.
                Al registrar una compra, el stock de cada producto se actualiza sumando la cantidad ingresada.
              </v-alert>
            </v-card-text>

          </v-card>
        </v-tab-item>

        <!-- ============================== -->
        <!-- TAB 2 — LISTADO                -->
        <!-- ============================== -->
        <v-tab-item value="two">
          <v-card flat>
            <v-card-text>

              <v-text-field
                v-model="buscador"
                placeholder="Ejemplo: 5, 12"
                outlined
              >
                <template v-slot:label>
                  <v-icon style="vertical-align: middle">mdi-magnify</v-icon>
                  Búsqueda por N° de Comprobante
                </template>
              </v-text-field>

              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead class="thead-dark">
                    <tr>
                      <th>ID</th>
                      <th>N° Comprobante</th>
                      <th>Condición</th>
                      <th>Exenta</th>
                      <th>Gravada 5%</th>
                      <th>Gravada 10%</th>
                      <th>Total</th>
                      <th>Fecha Registro</th>
                      <th>Editar</th>
                      <th>Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="compra in comprasBuscadas" :key="compra.id">
                      <td>{{ compra.id }}</td>
                      <td>{{ compra.comprobante_numero }}</td>
                      <td>{{ compra.condicion }}</td>
                      <td>{{ compra.total_excenta }}</td>
                      <td>{{ compra.total_gravada5 }}</td>
                      <td>{{ compra.total_gravada10 }}</td>
                      <td>{{ compra.monto_total }}</td>
                      <td>{{ compra.fecha_registro }}</td>
                      <td>
                        <v-btn small color="primary" outlined @click="openEditarCompraDialog(compra)">
                          <v-icon left small>mdi-pencil</v-icon> Editar
                        </v-btn>
                      </td>
                      <td>
                        <v-btn icon small color="red" @click="eliminarCompra(compra)">
                          <v-icon>mdi-delete-forever</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-card>

  </div>
</template>

<script>
import compraService from '@/services/compraService';
import productoService from '@/services/tienda/productoService';
import ProductosDialogCompra from '@/components/tienda/compra/ProductosDialogCompra.vue';
import EditarCompraDialog from '@/components/tienda/compra/EditarCompraDialog.vue';

export default {
  name: 'RegistroCompraAdmin',
  components: { ProductosDialogCompra, EditarCompraDialog },

  computed: {
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      }
    },

    ivaCalculado5() {
      return Math.round((this.compra.total_gravada5 || 0) / 11);
    },

    ivaCalculado10() {
      return Math.round((this.compra.total_gravada10 || 0) / 11);
    },

    montoTotalCalculado() {
      return (
        parseFloat(this.compra.total_excenta || 0) +
        parseFloat(this.compra.total_gravada5 || 0) +
        parseFloat(this.compra.total_gravada10 || 0)
      );
    },

    comprasBuscadas() {
      return this.compras.filter(c =>
        String(c.comprobante_numero).includes(this.buscador)
      );
    }
  },

  data() {
    return {
      valid: true,
      buscador: '',
      compras: [],

      compra: {
        condicion: 'CONTADO',
        total_excenta: 0,
        total_gravada5: 0,
        total_iva5: 0,
        total_gravada10: 0,
        total_iva10: 0,
        monto_total: 0,
        obs: '',
        // campos informativos — los asigna el backend
        comprobante_numero: '',
        fecha_registro: '',
        fecha_documento: ''
      },

      detalles: [],

      detalleActual: {
        producto: null,
        cantidad: 1,
        precio_costo: 0
      },

      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        timeout: 5000,
        colorBtn: 'white'
      }
    };
  },

  mounted() {
    this.listarCompras();
    this.tab = 'two';
  },

  methods: {

    recalcularTotales() {
      this.compra.total_iva5 = this.ivaCalculado5;
      this.compra.total_iva10 = this.ivaCalculado10;
      this.compra.monto_total = this.montoTotalCalculado;
    },

    agregarDetalle() {
      if (!this.detalleActual.producto) {
        this.mensajeError('Debe seleccionar un producto');
        return;
      }
      if (this.detalleActual.cantidad <= 0) {
        this.mensajeError('La cantidad debe ser mayor a 0');
        return;
      }
      this.detalles.push({ ...this.detalleActual });

      // Recalcular gravada 10 sumando subtotales de todos los detalles
      this.compra.total_gravada10 = this.detalles.reduce((acc, d) => {
        return acc + (d.cantidad * d.precio_costo);
      }, 0);

      this.recalcularTotales();

      this.detalleActual = { producto: null, cantidad: 1, precio_costo: 0 };
    },

    quitarDetalle(index) {
      this.detalles.splice(index, 1);

      // Recalcular gravada 10 tras quitar una línea
      this.compra.total_gravada10 = this.detalles.reduce((acc, d) => {
        return acc + (d.cantidad * d.precio_costo);
      }, 0);

      this.recalcularTotales();
    },

    recibirProducto(producto) {
      this.detalleActual.producto = producto;
      // Sugerir precio de costo del producto si tiene uno cargado
      if (producto.pcu && parseFloat(producto.pcu) > 0) {
        this.detalleActual.precio_costo = parseFloat(producto.pcu);
      }
    },

    async registrar() {
      if (!this.$refs.form.validate()) return;

      // Sincronizar IVA y total antes de enviar
      this.recalcularTotales();

      const payload = {
        compra: {
          condicion: this.compra.condicion,
          total_excenta: this.compra.total_excenta,
          total_gravada5: this.compra.total_gravada5,
          total_iva5: this.ivaCalculado5,
          total_gravada10: this.compra.total_gravada10,
          total_iva10: this.ivaCalculado10,
          monto_total: this.montoTotalCalculado,
          obs: this.compra.obs
        },
        detalles: this.detalles.map(d => ({
          producto_id: d.producto.id,
          cantidad: d.cantidad,
          precio_costo: d.precio_costo,
          precio_costo_total: d.cantidad * d.precio_costo
        }))
      };

      try {
        await compraService.save(payload);
        this.mensajeOk('Compra registrada correctamente');
        this.limpiar();
        this.listarCompras();
      } catch (error) {
        const msg = error.response?.data?.message || 'Error al registrar la compra';
        this.mensajeError(msg);
      }
    },

    async eliminarCompra(compra) {
      if (!confirm('¿Desea eliminar la compra N° ' + compra.comprobante_numero + '?')) return;
      try {
        await compraService.delete(compra.id);
        this.mensajeOk('Compra eliminada correctamente');
        this.listarCompras();
      } catch (error) {
        this.mensajeError('Error al eliminar la compra');
      }
    },

    listarCompras() {
      compraService.listarCompras()
        .then(res => { this.compras = res.data.data; })
        .catch(() => { this.mensajeError('Error al cargar las compras'); });
    },

    openEditarCompraDialog(compra) {
      this.$refs.editarCompraDialog.openDialog(compra);
    },

    despuesDeActualizar() {
      this.mensajeOk('Compra actualizada correctamente');
      this.listarCompras();
    },

    limpiar() {
      this.compra = {
        condicion: 'CONTADO',
        total_excenta: 0,
        total_gravada5: 0,
        total_iva5: 0,
        total_gravada10: 0,
        total_iva10: 0,
        monto_total: 0,
        obs: '',
        comprobante_numero: '',
        fecha_registro: '',
        fecha_documento: ''
      };
      this.detalles = [];
      this.detalleActual = { producto: null, cantidad: 1, precio_costo: 0 };
      this.$refs.form?.resetValidation();
    },

    mensajeOk(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'success', timeout: 5000, colorBtn: 'white' };
    },

    mensajeError(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'error', timeout: 5000, colorBtn: 'white' };
    }
  }
};
</script>
